import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageContentFormComponent } from './components/page-content-form/page-content-form.component';
import { featureFlagGuard } from '../core/feature-flags/feature-flag-guard';
import { Features } from '../core/feature-flags/features';
import { CanDeactivateGuard } from '../core/guards/can-deactivate.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'new', pathMatch: 'full' },
      {
        path: 'new',
        component: PageContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.PAGE, true, '/#/content/create/2'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id',
        pathMatch: 'full',
        component: PageContentFormComponent,
        canActivate: [featureFlagGuard(Features.PAGE, true, '/#/content/:id')],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id/edit',
        component: PageContentFormComponent,
        canActivate: [featureFlagGuard(Features.PAGE, true, '/#/content/:id')],
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesContentRoutingModule {}
